import * as ko from "knockout";
import Bao from "../../../services/bao-service";
import SubscriptionViewModel from "../../../factories/subscription-view-model";
import RoleShiftbookTabDialog from "./role-shiftbook-tab-dialog";

/*
 * ViewModel of ShiftEvent Tab for RoleShiftbookDialog
 * */
class RoleShiftbookTabDialogGeneralTab extends SubscriptionViewModel {
    RoleShiftbookTabDialog: RoleShiftbookTabDialog = null;
    ShiftbookTabId: KnockoutObservable<string>;

    constructor(tabPage: Factories.TabPage, parent: any) {
        super(tabPage);
        this.RoleShiftbookTabDialog = parent.ViewModel();
    }

    init() {
        return this.LoadData();

    }

    loaded() {
        this.TabPage.IsLoading(false);
    }

    /*
    * Gets and sets the model for the model view
    * */
    LoadData() {
        this.TabPage.IsLoading(true);
        return Bao.post("RoleShiftbookTab/GetItemRoleShiftbook", JSON.stringify({
            parentId: this.RoleShiftbookTabDialog.IsShiftbookContext() ? this.RoleShiftbookTabDialog.ShiftbookId() : this.RoleShiftbookTabDialog.RoleId(),
            sessionTabId: this.RoleShiftbookTabDialog.Parent.SessionTabId,
            id: this.RoleShiftbookTabDialog.RoleShiftbookId(),
            roleId: this.RoleShiftbookTabDialog.RoleId(),
            shiftbookId: this.RoleShiftbookTabDialog.ShiftbookId()

        })).then(result => {
            ko.map.fromJS(result, this);
        }).always(_ => this.TabPage.IsLoading(false));
    }
}
export default RoleShiftbookTabDialogGeneralTab;